<template>
  <div>
    <b-modal
      ref="edit_event"
      id="edit_event"
      size="lg"
      title="Izmeni događaj"
      @shown="focusTitle"
      @hide="hideModal"
    >
      <b-alert variant="danger" show v-if="isError">Došlo je do greške prilikom slanja.</b-alert>
      <b-form-group label="Naziv">
        <b-form-input
          ref="focusThis"
          v-model="event.title"
          size="lg"
          placeholder="Unesite naziv događaja"
        />
      </b-form-group>
      <b-form-group label="Opis">
        <b-textarea v-model="event.description" rows="4" placeholder="Kratak opis događaja..."></b-textarea>
      </b-form-group>
      <b-form-group label="Lokacija">
        <b-form-input
          ref=""
          v-model="event.location"         
          placeholder="Mesto održavanja aktivnosti"
        />
      </b-form-group>
      <b-form-group label="Početak">
        <b-form-datepicker
          v-model="event.start"
          locale="sr-Latn-RS"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :min="today"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group label="Kraj">
        <b-form-datepicker
          v-model="event.end"
          locale="sr-Latn-RS"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :min="event.start || today"
        ></b-form-datepicker>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="hideModal">Odustani</b-button>
        <b-button variant="success" class="mr-2" @click.prevent="submit()" :disabled="sending">
          <b-spinner v-if="sending" small></b-spinner>
          <em v-else>
            <i class="fas fa-paper-plane"></i>
          </em>
          Pošalji
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      today: new Date(),

      sending: false,
      isError: false
    };
  },
  computed: {
    ...mapGetters({ event: "calendar/curEvent" })
  },
  methods: {
    ...mapMutations({ setEvent: "calendar/setEvent" }),
    ...mapActions({ updateEvent: "calendar/updateEvent" }),
    show() {
      this.$refs.edit_event.show();
    },
    submit() {
      this.sending = true;
      let vm = this;
      this.updateEvent()
        .then(res => {
          vm.hideModal();
          this.makeToast(
            "success",
            "Izmenjeno!",
            "Događaj " + res.title + " je izmenjen!"
          );
          this.$emit('event-updated');
        })
        .catch(err => {
          console.log(err);
          this.isError = true;
        })
        .then(() => {
          this.sending = false;
        });
    },
    focusTitle() {
      this.$refs.focusThis.focus();
    },
    hideModal() {
      this.$refs["edit_event"].hide();
      this.isError = false;
      this.sending = false;
      //this.$emit("reset-event");
    }
  }
};
</script>

<style>
</style>